/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkedAppointmentOptions
 */
export interface LinkedAppointmentOptions {
    /**
     * Cancel all appts when this one is cancelled?
     * @type {boolean}
     * @memberof LinkedAppointmentOptions
     */
    cancel_all?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LinkedAppointmentOptions
     */
    hide_from_patient?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LinkedAppointmentOptions
     */
    is_optional?: boolean;
}

/**
 * Check if a given object implements the LinkedAppointmentOptions interface.
 */
export function instanceOfLinkedAppointmentOptions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LinkedAppointmentOptionsFromJSON(json: any): LinkedAppointmentOptions {
    return LinkedAppointmentOptionsFromJSONTyped(json, false);
}

export function LinkedAppointmentOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkedAppointmentOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cancel_all': !exists(json, 'cancel_all') ? undefined : json['cancel_all'],
        'hide_from_patient': !exists(json, 'hide_from_patient') ? undefined : json['hide_from_patient'],
        'is_optional': !exists(json, 'is_optional') ? undefined : json['is_optional'],
    };
}

export function LinkedAppointmentOptionsToJSON(value?: LinkedAppointmentOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cancel_all': value.cancel_all,
        'hide_from_patient': value.hide_from_patient,
        'is_optional': value.is_optional,
    };
}

